import { render, staticRenderFns } from "./TasksReport.vue?vue&type=template&id=4ab56fca&scoped=true&"
import script from "./TasksReport.vue?vue&type=script&lang=js&"
export * from "./TasksReport.vue?vue&type=script&lang=js&"
import style0 from "./TasksReport.vue?vue&type=style&index=0&id=4ab56fca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab56fca",
  null
  
)

export default component.exports